import { TableColumn } from '../../../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { PfizerPreTaskSafetyPlan } from './pfizer-pre-task-safety-plan.model';

export class PfizerPreTaskSafetyPlanListItem {
  /** When the form was submitted ("Entry Date" column) */
  submissionDate: Date | null = null;

  /** The person who submitted the form ("User" column) */
  submittedByName: string = '';

  /** The plan date ("Date" column) */
  date: Date | null = null;


  id: string = '';
  subcontractor: string = '';
  jobName: string = '';
  taskDescription: string = '';
  forepersonFirstName: string = '';
  forepersonLastName: string = '';

  constructor(data?: Partial<PfizerPreTaskSafetyPlanListItem>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static getTableColumns(): TableColumn[] {
    const columns: TableColumn[] = [];
    const instance = new PfizerPreTaskSafetyPlanListItem();
    const fieldMappings = PfizerPreTaskSafetyPlan.getFieldMappings();
    
    // Get all properties of the class
    Object.keys(instance).forEach(key => {
      // Skip the id property as it's handled separately
      if (key === 'id') return;

      // Determine the type based on the property value
      let type: 'text' | 'date' | 'action' | 'status' = 'text';
      const value = instance[key as keyof PfizerPreTaskSafetyPlanListItem];
      
      if (value instanceof Date || (value === null && key.toLowerCase().includes('date'))) {
        type = 'date';
      }
      // All other values default to 'text' type

      // Add the column if it has a mapping
      if (fieldMappings[key]) {
        columns.push({
          key,
          label: fieldMappings[key],
          type,
          sortable: true
        });
      }
    });

    

    return columns;
  }

  static fromApiResponse(data: any): PfizerPreTaskSafetyPlanListItem {
    return new PfizerPreTaskSafetyPlanListItem({
      id: data.id,
      submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
      submittedByName: data.submittedByName,
      date: data.date ? new Date(data.date) : null,
      subcontractor: data.subcontractor,
      jobName: data.jobName,
      taskDescription: data.taskDescription,
      forepersonFirstName: data.forepersonFirstName,
      forepersonLastName: data.forepersonLastName,
  
    });
  }
} 